import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControlLabel,
  FormGroup,
  Button,
  TextField,
  Checkbox,
  Grid,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import React from "react";

import HelperText from "../../../../components/feedback/helper-text";
import { language } from "../../../../language";
import { getUnitPropertie } from "../../../smart/camunda/forms/functions";
import ExtraFieldsComponent from "../extraFields";
import { findIndexDefaultValue, getPropertieObjectById } from "../helper";
import DisableFieldOptions from "../options/disable-field-options";

export default class ComponentSelect {
  static DisplayTab(props) {
    const { onChange, onCheckChange, state, onPropertieChange, error } = props;
    const required = getUnitPropertie(state, "required");
    const readOnly = getUnitPropertie(state, "readOnly");
    const hidden = getUnitPropertie(state, "hidden");
    const isRequired = getUnitPropertie(state, "isRequired");
    const fullWidth = getUnitPropertie(state, "fullWidth");
    const label = getUnitPropertie(state, "label");
    const toolTip = getUnitPropertie(state, "toolTip");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="id"
            variant="outlined"
            id="id"
            label="Id"
            value={state.id || ""}
            fullWidth
            helperText={language.toolTipId}
          />
        </Grid>
        <Grid item size={12}>
          <TextField
            onChange={onPropertieChange}
            name="label"
            variant="outlined"
            id="label"
            label={language.propertieLabel}
            value={label || ""}
            fullWidth
            helperText={language.toolTipLabel}
          />
        </Grid>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="description"
            variant="outlined"
            id="descricao"
            label={language.descricao}
            value={state.description || ""}
            fullWidth
            helperText={language.toolTipDescription}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={onPropertieChange}
            name="toolTip"
            variant="outlined"
            id="standard-basic"
            label={language.propertieToolTip}
            value={toolTip || ""}
            multiline
            rows="4"
            fullWidth
            helperText={language.toolTipToolTip}
          />
        </Grid>

        <Grid item size={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  name="isRequired"
                  onChange={(event) => onCheckChange(event)}
                  value={isRequired}
                  checked={isRequired || false}
                />
              }
              label={language.propertieRequired}
            />
          </FormGroup>
        </Grid>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="required"
            variant="outlined"
            id="standard-basic"
            label={language.propertieRequired}
            value={required || ""}
            disabled={!isRequired}
            error={!!getPropertieObjectById(error, "required")}
            fullWidth
          />
          {error && getPropertieObjectById(error, "required") && (
            <HelperText>{language.requirederror}</HelperText>
          )}
        </Grid>

        <Grid item size={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  name="readOnly"
                  onChange={(event) => onCheckChange(event)}
                  value={readOnly}
                  checked={readOnly || false}
                />
              }
              label={language.propertieReadonly}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="hidden"
                  onChange={(event) => onCheckChange(event)}
                  value={hidden}
                  checked={hidden || false}
                />
              }
              label={language.propertieHidden}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="fullWidth"
                  onChange={(event) => onCheckChange(event)}
                  value={fullWidth}
                  checked={fullWidth || false}
                />
              }
              label={language.propertieFullWidth}
            />
          </FormGroup>
        </Grid>
      </Grid>
    );
  }

  static ValidationTab(props) {
    const {
      addRowDefaultValue,
      state,
      handleDefaultValueChange,
      handleDefaultValueType,
      deleteDefaultValueRow,
      onPropertieChange,
      onCheckChange,
      setObjeto,
      handlePropertieChangeDataList,
      dataList,
    } = props;

    const index = findIndexDefaultValue(state, "options");
    const variableName = getUnitPropertie(state, "variableName");
    const jsonFieldValue = getUnitPropertie(state, "jsonFieldValue");
    const jsonFieldText = getUnitPropertie(state, "jsonFieldText");

    const dataListValue = getUnitPropertie(state, "dataList");
    const dataListColumn = getUnitPropertie(state, "dataListColumn");

    const defaultobj = state.properties[index];

    const dataListContent = dataList?.content || [];
    const selectedDataList = dataListContent.find(
      (d) => d.id === dataListValue?.id,
    );
    const dataListColumnsList =
      selectedDataList?.columns?.map((c) => c.name) || [];

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            select
            onChange={(event) => handleDefaultValueType(event)}
            name="options"
            variant="outlined"
            id="options"
            label={language.datasourceType}
            value={defaultobj && defaultobj.type}
            fullWidth
          >
            <MenuItem value="options">{language.values}</MenuItem>
            <MenuItem value="api">{language.api}</MenuItem>
            <MenuItem value="dataList">{language.DataList}</MenuItem>
            <MenuItem value="variable">{language.processVariable}</MenuItem>
          </TextField>
        </Grid>
        {defaultobj && defaultobj.type === "options" && (
          <>
            <Grid item size={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => addRowDefaultValue("options")}
                startIcon={<AddIcon />}
              >
                {language.addNew}
              </Button>
            </Grid>
            <Grid item size={12}>
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>{language.itemkey}</TableCell>
                      <TableCell>{language.value}</TableCell>
                      <TableCell>{language.text}</TableCell>
                      <TableCell align="right" width="50px" />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {defaultobj &&
                      defaultobj.value &&
                      defaultobj.value.map((item, index) => {
                        return (
                          <TableRow key={`tr_${index}`}>
                            <TableCell>
                              <input
                                style={{ width: "100%" }}
                                name="key"
                                value={defaultobj.value[index].key || ""}
                                onChange={(event) =>
                                  handleDefaultValueChange(
                                    event,
                                    index,
                                    "options",
                                  )
                                }
                              />
                            </TableCell>
                            <TableCell>
                              <input
                                style={{ width: "100%" }}
                                name="value"
                                value={defaultobj.value[index].value || ""}
                                onChange={(event) =>
                                  handleDefaultValueChange(
                                    event,
                                    index,
                                    "options",
                                  )
                                }
                              />
                            </TableCell>
                            <TableCell>
                              <input
                                style={{ width: "100%" }}
                                name="text"
                                value={defaultobj.value[index].text || ""}
                                onChange={(event) =>
                                  handleDefaultValueChange(
                                    event,
                                    index,
                                    "options",
                                  )
                                }
                              />
                            </TableCell>
                            <TableCell align="right">
                              <DeleteIcon
                                sx={{ cursor: "pointer" }}
                                onClick={() =>
                                  deleteDefaultValueRow(index, "options")
                                }
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </>
        )}

        {defaultobj && defaultobj.type === "api" && (
          <>
            <Grid item size={12}>
              <TextField
                fullWidth
                onChange={(event) =>
                  handleDefaultValueChange(event, 0, "options")
                }
                name="api"
                variant="outlined"
                id="api"
                label="URL"
                value={defaultobj.value}
              />
            </Grid>
            <Grid item size={12}>
              <TextField
                fullWidth
                onChange={(event) => onPropertieChange(event)}
                name="jsonFieldValue"
                variant="outlined"
                id="jsonFieldValue"
                label={language.jsonFieldValue}
                value={jsonFieldValue || ""}
              />
            </Grid>
            <Grid item size={12}>
              <TextField
                fullWidth
                onChange={(event) => onPropertieChange(event)}
                name="jsonFieldText"
                variant="outlined"
                id="jsonFieldText"
                label={language.jsonFieldText}
                value={jsonFieldText || ""}
              />
            </Grid>
            <Grid item size={12}>
              <ExtraFieldsComponent {...props} />
            </Grid>
          </>
        )}
        {defaultobj && defaultobj.type === "variable" && (
          <>
            <Grid item size={12}>
              <TextField
                fullWidth
                onChange={(event) => onPropertieChange(event)}
                name="variableName"
                variant="outlined"
                id="variableName"
                label={language.variableName}
                value={variableName || ""}
              />
            </Grid>
            <Grid item size={12}>
              <TextField
                fullWidth
                onChange={(event) => onPropertieChange(event)}
                name="jsonFieldValue"
                variant="outlined"
                id="jsonFieldValue"
                label={language.jsonFieldValue}
                value={jsonFieldValue || ""}
              />
            </Grid>
            <Grid item size={12}>
              <TextField
                fullWidth
                onChange={(event) => onPropertieChange(event)}
                name="jsonFieldText"
                variant="outlined"
                id="jsonFieldText"
                label={language.jsonFieldText}
                value={jsonFieldText || ""}
              />
            </Grid>
          </>
        )}

        {defaultobj && defaultobj.type === "dataList" && (
          <>
            <Grid item size={12}>
              <TextField
                fullWidth
                select
                labelId="datalist-type-label"
                id="datalist-type-select"
                name="dataList"
                value={dataListValue}
                onChange={(event) => handlePropertieChangeDataList(event)}
                label={language.chooseAList}
                renderValue={(selected) => (selected ? selected.name : "")}
              >
                {dataListContent.map((dataValue) => {
                  return (
                    <MenuItem key={dataValue.id} value={dataValue}>
                      {dataValue.name}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>

            <Grid item size={12}>
              <TextField
                select
                fullWidth
                labelId="datalist-column-type-label"
                id="datalist-column-type-select"
                name="dataListColumn"
                value={dataListColumn}
                onChange={(event) => onPropertieChange(event)}
                label={language.chooseAColumnFromTheList}
                renderValue={(selected) => selected || ""}
              >
                {dataListColumnsList.map((dataColumn, index) => {
                  return (
                    <MenuItem key={`${index}_${dataColumn}`} value={dataColumn}>
                      {dataColumn}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
          </>
        )}
        <Grid item size={12}>
          <DisableFieldOptions
            onCheckChange={onCheckChange}
            onPropertieChange={onPropertieChange}
            handleDefaultValueChange={handleDefaultValueChange}
            addRowDefaultValue={addRowDefaultValue}
            deleteDefaultValueRow={deleteDefaultValueRow}
            state={state}
            setObjeto={setObjeto}
          />
        </Grid>
      </Grid>
    );
  }

  static StylesTab(props) {
    const { onPropertieChange, state } = props;
    const propertieCSS = getUnitPropertie(state, "propertieCSS");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="propertieCSS"
            variant="outlined"
            id="standard-basic"
            label={language.propertieCSS}
            value={propertieCSS || ""}
            multiline
            rows="4"
            fullWidth
            helperText={language.toolTipCSS}
          />
        </Grid>
      </Grid>
    );
  }
}
